import React from 'react';
export function TopBar() {
  return <div className="bg-brand-anthracite border-b border-brand-card text-brand-muted text-[10px] md:text-xs tracking-[0.14em] uppercase py-2.5 px-4 text-center" data-id="element-93" data-mp="1ymsm7yldi5m0">
      Archivo digital · 6 tomos + 3 investigaciones · Acceso inmediato · Pago
      único
    </div>;
}